// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__s4fH0","footerContainer":"styles_footerContainer__JtRd8","social":"styles_social__9m-xR","logoFooter":"styles_logoFooter__kKmfu"};